<ng-container *abcLet="res$ | async as res">
  <abc-popup
    #networkTracingPopup
    [title]="res.get('NetworkTracing-PopupTitle')"
    [showTitle]="true"
    [ngStyle]="{ height: '300px' }"
    [ngStyle.xs]="{ height: '306px' }"
    [ngStyle]="{ width: '524px' }"
    [ngStyle.xs]="{ width: '334px' }"
    [maxHeight]="'306px'"
    [maxWidth]="'524px'"
    [visible]="isPopupVisible"
    [shading]="false"
    [position]="{
      my: 'top left',
      at: 'top left',
      offset: '60 10'
    }"
  >
    <div fxLayout="column" fxLayoutGap="4px" class="popup-content">
      <div fxLayout="row">
        <abc-drop-down-box
          #dropDownPipe
          [height]="'35px'"
          [label]="res.get('NetworkTracing-StartLine')"
          [ngStyle]="{ width: '484px' }"
          [ngStyle.xs]="{ width: '294px' }"
          [(value)]="selectedPipeId"
        ></abc-drop-down-box>
      </div>
      <div fxLayout="row" fxLayoutGap="4px">
        <abc-drop-down-box
          #dropDownEdgeDirection
          [height]="'35px'"
          [ngStyle]="{ width: '240px' }"
          [ngStyle.xs]="{ width: '145px' }"
          [label]="res.get('NetworkTracing-FlowDirection')"
          [(value)]="edgeDirection"
        ></abc-drop-down-box>
        <abc-number-box
          #maxEdgeNumberBox
          [height]="'35px'"
          [ngStyle]="{ width: '240px' }"
          [ngStyle.xs]="{ width: '145px' }"
          [showClearButton]="true"
          [label]="res.get('NetworkTracing-NumberOfEdges')"
          [min]="1"
          [(value)]="maxEdgeCount"
        ></abc-number-box>
      </div>
      <div fxLayout="row" fxLayoutGap="4px">
        <abc-drop-down-box
          #filterModeDropDown
          [height]="'35px'"
          [ngStyle]="{ width: '240px' }"
          [ngStyle.xs]="{ width: '145px' }"
          [label]="res.get('NetworkTracing-AreaFilter')"
          [(value)]="edgeFilterMode"
          (onValueChanged)="onFilterModeChanged($event)"
        ></abc-drop-down-box>
        <abc-drop-down-box
          #filterValueDropDown
          [height]="'35px'"
          [ngStyle]="{ width: '240px' }"
          [ngStyle.xs]="{ width: '145px' }"
          [label]="res.get('NetworkTracing-RangeFilter')"
          [(value)]="edgeFilterValue"
        ></abc-drop-down-box>
      </div>
      <div fxLayout="row">
        <abc-drop-down-box
          #stopSearchDropDown
          [height]="'35px'"
          [ngStyle]="{ width: '484px' }"
          [ngStyle.xs]="{ width: '294px' }"
          [label]="res.get('NetworkTracing-Abort')"
          [(value)]="searchStopOption"
        ></abc-drop-down-box>
      </div>
      <div fxLayout="row" fxLayoutGap="4px" class="checkbox-container">
        <abc-check-box
          #connectionPipeCheck
          class="checkbox-text"
          [text]="res.get('NetworkTracing-PipeConnectionCheck')"
          [(value)]="includeConnectionPipe"
          [ngStyle]="{ width: '240px' }"
          [ngStyle.xs]="{ width: '145px' }"
        >
        </abc-check-box>
        <abc-check-box
          #onlyStartEndCheck
          class="checkbox-text"
          [text]="res.get('NetworkTracing-OnlyStartEndLinesCheck')"
          [(value)]="onlyStartEndEdges"
          [ngStyle]="{ width: '240px' }"
          [ngStyle.xs]="{ width: '145px' }"
        >
        </abc-check-box>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
        <abc-button
          fxFlex="35"
          class="button-text"
          [text]="res.get('NetworkTracing-Ok')"
          (onClick)="onNetworkTracing()"
        ></abc-button>
        <abc-button
          fxFlex="35"
          class="button-text"
          [text]="res.get('NetworkTracing-Cancel')"
          (onClick)="onPopupClosed()"
        ></abc-button>
      </div>
    </div>
  </abc-popup>
</ng-container>
